import { adTechLog } from './log';
/**
 * Lazy load functionality for a callback execution based on an elements position regarding the viewport.
 *
 * @param {String} elementID
 * @param {function} callback The callback function
 * @param {null|undefined|Object} params Optional params to run with the callback function.
 * @param {Number} topOffsetPercent The top offset.
 * @param {Number} rightOffsetPercent The right offset.
 * @param {Boolean} callOnce To call the callback once only at the trigger point.
 */
export const onLazyLoad = ( elementID, callback, params= null, topOffsetPercent = 0, rightOffsetPercent = 0, callOnce = true ) => {

	let scrolling = false;

	/**
	 * The callback function wrapped in checks to see if its a function and if the params are set.
	 */
	const callbackFunc = function() {
		if ( 'function' === typeof callback ) {

			// Log the event.
			adTechLog( {
				type: 'event',
				message: `onLazyLoad: lazyload event triggered for element: "${elementID}".`,
			} );

			'undefined' === typeof params || null === params ? callback() : callback( params );
		}
	}

	if ( typeof topOffsetPercent !== 'number' || 0 === topOffsetPercent ) {
		topOffsetPercent = 0; // Force zero.
	} else {
		topOffsetPercent /= 100; // convert to percentage for multiplication.
	}

	if ( typeof rightOffsetPercent !== 'number' || 0 === rightOffsetPercent ) {
		rightOffsetPercent = 0; // Force zero.
	} else {
		rightOffsetPercent /= 100; // convert to percentage for multiplication.
	}

	const scrollEvent = () => {
		const element = document.getElementById( elementID );

		// Bail early.
		if ( scrolling ) {
			return;
		} else {
			scrolling = true;
		}

		// Reset and allow scrolling.
		setTimeout( () => {
			scrolling = false;
		}, 200 );

		if ( element ) {
			// Get it's position in the viewport
			var bounding = element.getBoundingClientRect(),
				viewPortHeight = window.innerHeight || document.documentElement.clientHeight,
				topBoundary = ( bounding.top - viewPortHeight * topOffsetPercent ),
				viewPortWidth = window.innerWidth || document.documentElement.clientWidth,
				rightBoundary = ( bounding.right - viewPortWidth * rightOffsetPercent );

			if ( bounding.bottom >= 0 &&
				bounding.left >= 0 &&
				rightBoundary <= viewPortWidth &&
				topBoundary <= viewPortHeight ) {

				callbackFunc();

				if ( callOnce ) {
					window.removeEventListener( 'scroll', scrollEvent );
				}
			}
		}
	};

	window.addEventListener( 'scroll', scrollEvent );
}